import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import HtmlToPdf from '@/libs/html_to_pdf.js'
import util from '@/common/util.js' //自定义方法
import http from '@/common/http.js' //请求封装
import components from './components' //全局组件
import '@/common/permission' // permission control
import popups from "./common/popups.js"



import Permission from "./libs/permission";

import Printer from '@/libs/mes_printer.js'

// import Prints from 'vue-print-nb'
// Vue.use(Prints)
// Vue.filter("dateFilter", (date) => {
//     console.log(date);
// })


// 导如全局图片
Vue.prototype.$imageObj = {
    delete: require("./assets/删除.png"),
    check: require("./assets/查看.png"),
    amend: require("./assets/修改.png"),
    increase: require("./assets/新增.png"),
    harvest: require("./assets/待收货.png"),
    print: require("./assets/print.png")
}

Vue.prototype.$popups = popups;
// console.log(popups.harvestRecordStyle());
//全局样式
import '@/style/index.scss'

import './plugins/element.js'
import md5 from 'js-md5';

import Print from 'vue-print-nb'
Vue.use(Print);
Vue.prototype.$md5 = md5;
Vue.directive("authority", {
    inserted(el, binding) {
        if (!Permission.Check(binding.value)) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    },
});
// v-authority="'权限代码'" 进行使用
Permission.setAuths()

Vue.use(HtmlToPdf)
Vue.use(components)
Vue.prototype.$permission = Permission
Vue.prototype.$request = http.request
Vue.prototype.$http = http
Vue.config.productionTip = false

Vue.prototype.$printer = Printer

Vue.prototype.$pictureUil = "http://10.178.112.7:9003/";
// Vue.prototype.$pictureUil = "http://47.100.161.175:9003/";

//TODO... 用户信息
Vue.prototype.userNameDefault = 'admin'
Vue.prototype.fcCodeDefault = 'DLM'

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')